@use "../../styles/icon-sizes";
@use "../../styles/text";
@use "mixin/link-text-basic-states";

hp6-link-text-basic {
  position: relative;
  display: inline;

  @include link-text-basic-states.basic-states;

  font-family: var(--text-body-font-md);
  font-weight: var(--text-body-weight-md);
  letter-spacing: var(--text-body-letter-spacing-md);

  // if no size is provided, inherits size and line-height from container
  font-size: inherit;
  line-height: inherit;

  &[size-selection="xl"] {
    @include text.text-body-xl;
    font-weight: inherit;
  }

  &[size-selection="lg"] {
    @include text.text-body-lg;
    font-weight: inherit;
  }

  &[size-selection="md"] {
    @include text.text-body-md;
    font-weight: inherit;
  }

  &[size-selection="sm"] {
    @include text.text-body-sm;
    font-weight: inherit;
  }

  &[size-selection="xs"] {
    @include text.text-body-xs;
    font-weight: inherit;
  }

  &[size-selection="xxs"] {
    @include text.text-body-xxs;
    font-weight: inherit;
  }
}
